<template>
  <div style="background: #fff">
    <div class="page_title" v-if="art_id">编辑患教文章</div>
    <div class="page_title" v-else>添加患教文章</div>
    <div class="container">
      <div class="essay">
        <div style="margin-bottom: 20px">
          <el-input
            v-model="title"
            placeholder="请输入标题"
            maxlength="30"
            show-word-limit
          ></el-input>
        </div>
        <div style="margin-bottom: 20px">
          <el-input
            v-model="author"
            placeholder="作者"
            maxlength="11"
            show-word-limit
          ></el-input>
        </div>
        <div style="margin-bottom: 20px">
          <el-input
            v-model="summary"
            placeholder="摘要"
            type="textarea"
            maxlength="100"
            show-word-limit
          ></el-input>
        </div>
        <div class="faceimg">
          <div class="imgbox">
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="image" :src="image_str" class="avatar" />

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div>
            <div style="font-weight: 700">封面图片</div>
            <div style="color: #f59a23">显示到患教文章封面</div>
          </div>
        </div>
        <div style="width: 100%; height: 100%">
          <wangeditor ref="editorBox" />
        </div>
        <div class="btnbox">
          <div>
            <el-button
              type="primary"
              round
              style="width: 100px; margin-right: 5px"
              @click="submit"
              >保存</el-button
            >
            <el-button plain round style="width: 100px" @click="back"
              >退出</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditor from './wangeditor';
import imgtext from '../../../api/imgtext';
import constant from '../../../service/common/constant';
import platform from '../../../api/platform';
import clinic from '../../../api/clinic';
export default {
  data() {
    return {
      title: '',
      summary: '',
      image: '',
      author: '歧黄医官 | 编辑整理',
      content: '',
      art_id: this.$route.query.art_id,
      department_id: this.$route.query.department_id,

      image: '',
      image_str: '',
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      }
    };
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  components: {
    wangeditor
  },
  methods: {
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        //半路径
        this.image = res.data.pic;
        //绝对路径
        this.image_str = res.data.path;
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    //往编辑器里插入数据
    setDesc(text) {
      this.$refs.editorBox.editor.txt.html(text);
    },

    //发布
    submit() {
      if (!this.title) {
        this.$message.error('请填写标题');
        return false;
      }
      if (!this.summary) {
        this.$message.error('请填写摘要');
        return false;
      }
      if (!this.image) {
        this.$message.error('请上传封面图片');
        return false;
      }
      let content = this.$refs.editorBox.editor.txt.html();
      if (!content) {
        this.$message.error('请填写内容');
        return false;
      }

      let data = {
        title: this.title,
        content: content,
        summary: this.summary,
        author: this.author,
        image: this.image,
        art_id: this.art_id || 0,
        department_id: this.department_id
      };

      clinic.saveLibraryInfo(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.back();
        }
      });
    },
    //获取图文信息
    getDetail() {
      if (!this.art_id) {
        return false;
      }
      let art_id = this.art_id;
      clinic.getLibraryInfo({ art_id }).then((res) => {
        if (res.code == 0) {
          let detail = res.data.info;
          this.title = detail.title;
          this.summary = detail.summary;
          this.image = detail.image;
          this.image_str = detail.image_str;
          if (detail.author) {
            this.author = detail.author;
          }
          this.setDesc(detail.content);
        }
      });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 120px);
  background: #fff;
}
.essay {
  width: 70%;
  margin: 20px auto 0;
}
.btnbox {
  width: 100%;
  height: 58px;
  border: solid 1px #cfcece;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
}
.imgbox {
  width: 200px;
  height: 144px;
  box-sizing: border-box;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  margin-right: 20px;
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 32px;
  color: #8c939d;
  font-weight: 600;
  width: 200px;
  height: 144px;
  line-height: 144px;
  text-align: center;
}
.avatar {
  width: 200px;
  height: 144px;
  display: block;
}
.faceimg {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
}
</style>
